export default __webpack_public_path__ + "static/media/Silk-Serif-Black.60b5adfb.otf";